export default "__VITE_ASSET__8a54aec5__"